import React from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || process.env.CLERK_PUBLISHABLE_KEY || '';
function getThemeValue(name, fallback) {
    if (typeof window === 'undefined') {
        return fallback;
    }
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return value || fallback;
}
function buildAppearance() {
    const primary = getThemeValue('--primary', '#2563eb');
    const bgPrimary = getThemeValue('--bg-primary', '#ffffff');
    const textPrimary = getThemeValue('--text-primary', '#111827');
    const textSecondary = getThemeValue('--gray-600', '#4b5563');
    const borderColor = getThemeValue('--gray-200', '#e5e7eb');
    return {
        variables: {
            colorPrimary: primary,
            colorBackground: bgPrimary,
            colorText: textPrimary,
            colorTextSecondary: textSecondary,
            colorInputBackground: bgPrimary,
            colorInputText: textPrimary,
            colorNeutral: borderColor,
            borderRadius: '1rem',
            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            colorDanger: '#dc2626',
        },
        elements: {
            card: 'swimlab-clerk-card',
            headerTitle: 'swimlab-clerk-title',
            headerSubtitle: 'swimlab-clerk-subtitle',
            socialButtonsBlockButton: 'swimlab-clerk-social-button',
            formButtonPrimary: 'swimlab-clerk-primary-button',
            formFieldInput: 'swimlab-clerk-input',
            formFieldLabel: 'swimlab-clerk-label',
            footerActionLink: 'swimlab-clerk-footer-link',
            footer: 'swimlab-clerk-footer',
            logoBox: 'swimlab-clerk-logo',
        },
        layout: {
            logoPlacement: 'inside',
            logoImageUrl: '/icons/icon-192.png',
            logoLinkUrl: '/',
            socialButtonsPlacement: 'bottom',
        },
    };
}
export async function getClerkToken() {
    if (typeof window === 'undefined') {
        return null;
    }
    const clerk = window.Clerk;
    if (!clerk?.session) {
        return null;
    }
    try {
        return await clerk.session.getToken();
    }
    catch {
        return null;
    }
}
export function createClerkProvider(children) {
    if (!publishableKey) {
        console.warn('[clerk] Missing Clerk publishable key. Falling back to the existing app shell without Clerk auth.');
        return children;
    }
    return React.createElement(ClerkProvider, {
        publishableKey,
        appearance: buildAppearance(),
        afterSignOutUrl: '/',
        routerPush: (to) => window.history.pushState({}, '', to),
        routerReplace: (to) => window.history.replaceState({}, '', to),
    }, children);
}
